import { render, staticRenderFns } from "./Olx.vue?vue&type=template&id=79b6c7f2"
import script from "./Olx.vue?vue&type=script&lang=js"
export * from "./Olx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports